// ============================================================
//  JILBADA SHOPIFY — Adapted from Jilbada's script.js
//  Visual JS: loader, dua, hero slider, reveals, mobile menu,
//  size recommender, scroll header.
//  Cart: wired to Shopify AJAX cart (no localStorage).
// ============================================================

// ============ LOADER ============
window.addEventListener("load", () => {
  setTimeout(() => {
    const loader = document.getElementById("jilbada-loader");
    if (loader) {
      loader.classList.add("hidden");
      setTimeout(() => {
        if (!sessionStorage.getItem("jilbada_dua_shown")) {
          const overlay = document.getElementById("jilbada-dua-overlay");
          if (overlay) {
            overlay.classList.add("show");
            document.body.classList.add("dua-open");
            sessionStorage.setItem("jilbada_dua_shown", "true");
          }
        }
      }, 600);
    }
  }, 1400);
});

function closeDua() {
  const overlay = document.getElementById("jilbada-dua-overlay");
  if (overlay) {
    overlay.classList.remove("show");
    document.body.classList.remove("dua-open");
  }
}

// ============ HEADER SCROLL ============
const mainNav = document.getElementById("jilbada-nav");
if (mainNav) {
  window.addEventListener("scroll", () => {
    if (window.scrollY > 60) mainNav.classList.add("scrolled");
    else mainNav.classList.remove("scrolled");
  });
}

// ============ MOBILE MENU ============
function toggleMobile() {
  const overlay = document.getElementById("jilbada-mobile-overlay");
  if (overlay) overlay.classList.toggle("show");
}

// ============ SCROLL REVEAL ============
function observeReveals() {
  if (!("IntersectionObserver" in window)) return;
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("in-view");
        }
      });
    },
    { threshold: 0.12, rootMargin: "-30px 0px -30px 0px" },
  );
  document
    .querySelectorAll(".reveal:not(.in-view)")
    .forEach((el) => observer.observe(el));
}
observeReveals();

// ============ JOURNEY CONNECTING LINE ============
function drawJourneyLine() {
  const timeline = document.querySelector(".journey-timeline");
  if (!timeline) return;
  const markers = timeline.querySelectorAll(".journey-marker");
  if (markers.length < 2) return;
  const tlRect = timeline.getBoundingClientRect();
  const firstRect = markers[0].getBoundingClientRect();
  const lastRect = markers[markers.length - 1].getBoundingClientRect();
  const top = firstRect.top + firstRect.height / 2 - tlRect.top;
  const height = lastRect.top + lastRect.height / 2 - tlRect.top - top;
  let line = timeline.querySelector(".journey-connecting-line");
  if (!line) {
    line = document.createElement("div");
    line.className = "journey-connecting-line";
    timeline.appendChild(line);
  }
  line.style.top = top + "px";
  line.style.height = Math.max(0, height) + "px";
  const isMobile = window.innerWidth <= 700;
  if (isMobile) {
    const leftEdge =
      markers[0].getBoundingClientRect().left -
      tlRect.left +
      markers[0].offsetWidth / 2;
    line.style.left = leftEdge + "px";
    line.style.transform = "translateX(-50%)";
  } else {
    line.style.left = "";
    line.style.transform = "";
  }
}
window.addEventListener("resize", drawJourneyLine);
if (document.querySelector(".journey-timeline")) {
  setTimeout(drawJourneyLine, 500);
}

// ============ SIZE RECOMMENDER ============
function openRecommender() {
  const modal = document.getElementById("jilbada-recommender");
  if (modal) modal.classList.add("show");
}
function closeRecommender() {
  const modal = document.getElementById("jilbada-recommender");
  if (modal) modal.classList.remove("show");
}
function calculateSize() {
  const h = +document.getElementById("jilbada-height").value;
  const chest = +(document.getElementById("jilbada-chest") || {}).value || 0;
  const waist = +(document.getElementById("jilbada-waist") || {}).value || 0;
  const hips = +(document.getElementById("jilbada-hips") || {}).value || 0;

  if (!h || (!chest && !waist && !hips)) return;

  // Use largest measurement to ensure generous modesty coverage
  const ref = Math.max(chest, waist, hips);

  let size = "M";
  if (ref <= 88) size = "XS";
  else if (ref <= 96) size = "S";
  else if (ref <= 104) size = "M";
  else if (ref <= 112) size = "L";
  else if (ref <= 120) size = "XL";
  else size = "XXL";

  const resultEl = document.getElementById("jilbada-recommend-result");
  const sizeEl = document.getElementById("jilbada-recommended-size");
  if (sizeEl) sizeEl.textContent = size;
  if (resultEl) resultEl.classList.add("show");
}

// ============ INTERACTIVE BUTTONS ============
document.addEventListener("click", (e) => {
  // Size buttons
  if (e.target.matches(".size-btn")) {
    const parent = e.target.closest(".size-options, .size-list");
    if (parent)
      parent
        .querySelectorAll(".size-btn")
        .forEach((b) => b.classList.remove("selected"));
    e.target.classList.add("selected");
  }
  // Color options
  if (e.target.matches(".color-option")) {
    document
      .querySelectorAll(".color-option")
      .forEach((x) => x.classList.remove("selected"));
    e.target.classList.add("selected");
  }
  // Filter group buttons
  if (e.target.matches(".filter-group button")) {
    const parent = e.target.parentElement;
    parent
      .querySelectorAll("button")
      .forEach((b) => b.classList.remove("active"));
    e.target.classList.add("active");
  }
  // Qty selector
  if (e.target.matches(".qty-selector button")) {
    const input = e.target.parentElement.querySelector("input");
    let v = +input.value;
    if (e.target.textContent.trim() === "−") v = Math.max(1, v - 1);
    else v++;
    input.value = v;
  }
});

// ============ SHOPIFY CART INTEGRATION ============
// Delegates to popups.js openCartDrawer/closeCartDrawer (window.*) which
// handles #CartDrawer + .main__overlay correctly.
function openShopifyCartDrawer() {
  if (typeof window.openCartDrawer === "function") {
    window.openCartDrawer();
  } else {
    // Fallback for safety — popups.js may not have loaded yet
    const drawer = document.getElementById("CartDrawer");
    const overlay = document.querySelector(".main__overlay");
    if (drawer) drawer.classList.add("open");
    if (overlay) overlay.classList.add("active");
    document.body.style.overflow = "hidden";
  }
}

function closeShopifyCartDrawer() {
  if (typeof window.closeCartDrawer === "function") {
    window.closeCartDrawer();
  } else {
    const drawer = document.getElementById("CartDrawer");
    const overlay = document.querySelector(".main__overlay");
    if (drawer) drawer.classList.remove("open");
    if (overlay) overlay.classList.remove("active");
    document.body.style.overflow = "";
  }
}

// Cart count badge — sync with Shopify cart
function updateCartBadge(count) {
  const badge = document.getElementById("jilbada-cart-count");
  if (!badge) return;
  badge.textContent = count;
  badge.dataset.count = count;
  badge.style.display = count > 0 ? "flex" : "none";
}

function fetchCartCount() {
  fetch("/cart.js")
    .then((r) => r.json())
    .then((cart) => updateCartBadge(cart.item_count))
    .catch(() => {});
}
fetchCartCount();

// Listen for Shopify cart update events (pubsub from existing cart JS)
document.addEventListener("cart:updated", (e) => {
  if (e.detail && typeof e.detail.cart !== "undefined") {
    updateCartBadge(e.detail.cart.item_count);
  } else {
    fetchCartCount();
  }
});

// Cart icon click — event delegation so it fires even if element wasn't in DOM at load time
document.addEventListener("click", (e) => {
  if (e.target.closest("#jilbada-cart-btn")) {
    openShopifyCartDrawer();
  }
});

// Cart icon pulse on add
function pulseCartBtn() {
  const btn = document.getElementById("jilbada-cart-btn");
  if (!btn) return;
  btn.animate(
    [
      { transform: "scale(1)" },
      { transform: "scale(1.25)" },
      { transform: "scale(1)" },
    ],
    { duration: 500, easing: "cubic-bezier(.2,.8,.2,1)" },
  );
}

// Shopify add-to-cart via AJAX
function shopifyAddToCart(variantId, quantity) {
  if (!variantId) return;
  quantity = quantity || 1;
  const btn = document.querySelector(".shopify-add-to-cart");
  if (btn) btn.setAttribute("disabled", "");

  fetch("/cart/add.js", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ id: variantId, quantity }),
  })
    .then((r) => r.json())
    .then((item) => {
      pulseCartBtn();
      // Show loader before opening so drawer never flashes stale content
      const _drawer = document.getElementById("CartDrawer");
      if (_drawer) _drawer.classList.add("cart-loading");
      openShopifyCartDrawer();
      // Publish cart update so cart-drawer-kaleido.js runs section render and removes loader
      if (
        typeof publish === "function" &&
        typeof PUB_SUB_EVENTS !== "undefined"
      ) {
        publish(PUB_SUB_EVENTS.cartUpdate, { action: "add", variant: item });
      } else {
        if (_drawer) _drawer.classList.remove("cart-loading");
        fetchCartCount();
      }
    })
    .catch((err) => console.error("Add to cart failed:", err))
    .finally(() => {
      if (btn) btn.removeAttribute("disabled");
    });
}

// ============ COMING SOON — NOTIFY-ME ============
function notifyMe(e) {
  e.preventDefault();
  const form = e.target;
  const emailInput = form.querySelector("input[type=email]");
  if (!emailInput) return false;
  const email = emailInput.value.trim();
  if (!email) return false;
  // Store locally; in production, submit to Shopify customer or a Klaviyo/Mailchimp endpoint
  const stage = form.dataset.stage;
  const stored = JSON.parse(localStorage.getItem("jilbada_notify") || "{}");
  stored[stage] = stored[stage] || [];
  if (!stored[stage].includes(email)) stored[stage].push(email);
  localStorage.setItem("jilbada_notify", JSON.stringify(stored));
  form.classList.add("sent");
  return false;
}

// ============ SEARCH POPUP ============
(function () {
  const popup = document.getElementById("jilbada-search-popup");
  if (!popup) return;

  const input = popup.querySelector("[data-search-input]");
  const resultsEl = popup.querySelector("[data-search-results]");
  const suggestEl = popup.querySelector("[data-search-suggest]");
  const viewAll = popup.querySelector("[data-search-viewall]");
  const bodyEl = popup.querySelector(".jsearch__body");
  const form = popup.querySelector(".jsearch__form");
  const searchBase = (form && form.getAttribute("action")) || "/search";
  let controller = null;
  let debounce;

  function openSearch() {
    popup.classList.add("active");
    popup.setAttribute("aria-hidden", "false");
    document.body.style.overflow = "hidden";
    setTimeout(() => input && input.focus(), 350);
  }

  function closeSearch() {
    popup.classList.remove("active");
    popup.setAttribute("aria-hidden", "true");
    document.body.style.overflow = "";
  }
  window.openJilbadaSearch = openSearch;
  window.closeJilbadaSearch = closeSearch;

  // Open via header button / close via [data-search-close] — delegated so it
  // works regardless of load order.
  document.addEventListener("click", (e) => {
    if (e.target.closest("#jilbada-search-btn")) {
      e.preventDefault();
      openSearch();
    } else if (e.target.closest("[data-search-close]")) {
      closeSearch();
    }
  });

  const SUGGEST_URL =
    (window.routes && window.routes.predictive_search_url
      ? window.routes.predictive_search_url
      : "/search/suggest") + ".json";

  function esc(str) {
    return String(str == null ? "" : str)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;");
  }

  function renderResults(products, query) {
    if (!products.length) {
      resultsEl.innerHTML =
        '<p class="jsearch__empty">' +
        (document.body.classList.contains("rtl")
          ? "لا توجد نتائج مطابقة"
          : "No matches found") +
        "</p>";
    } else {
      resultsEl.innerHTML = products
        .map((p) => {
          const img =
            (p.featured_image && p.featured_image.url) || p.image || "";
          const imgTag = img
            ? '<div class="jsearch__result-img"><img src="' +
              esc(img) +
              '" alt="" loading="lazy"></div>'
            : '<div class="jsearch__result-img"></div>';
          const type = p.type
            ? '<span class="jsearch__result-type">' + esc(p.type) + "</span>"
            : "";
          return (
            '<a class="jsearch__result" href="' +
            esc(p.url) +
            '">' +
            imgTag +
            type +
            '<span class="jsearch__result-title">' +
            esc(p.title) +
            "</span></a>"
          );
        })
        .join("");
    }
    if (viewAll) {
      viewAll.hidden = false;
      viewAll.href =
        searchBase + "?q=" + encodeURIComponent(query) + "&type=product";
    }
  }

  function doSearch(query) {
    if (controller) controller.abort();
    controller = new AbortController();
    bodyEl.classList.add("jsearch__loading");
    fetch(
      SUGGEST_URL +
        "?q=" +
        encodeURIComponent(query) +
        "&resources[type]=product&resources[limit]=6" +
        "&resources[options][unavailable_products]=last",
      { signal: controller.signal },
    )
      .then((r) => r.json())
      .then((data) => {
        const products =
          (data.resources &&
            data.resources.results &&
            data.resources.results.products) ||
          [];
        renderResults(products, query);
      })
      .catch((err) => {
        if (err.name !== "AbortError") resultsEl.innerHTML = "";
      })
      .finally(() => bodyEl.classList.remove("jsearch__loading"));
  }

  if (input) {
    input.addEventListener("input", () => {
      const query = input.value.trim();
      clearTimeout(debounce);
      if (query.length < 2) {
        resultsEl.innerHTML = "";
        if (viewAll) viewAll.hidden = true;
        if (suggestEl) suggestEl.style.display = "";
        return;
      }
      if (suggestEl) suggestEl.style.display = "none";
      debounce = setTimeout(() => doSearch(query), 250);
    });
  }
})();

// ============ ESC TO CLOSE OVERLAYS ============
document.addEventListener("keydown", (e) => {
  if (e.key === "Escape") {
    closeDua();
    closeRecommender();
    closeShopifyCartDrawer();
    if (window.closeJilbadaSearch) window.closeJilbadaSearch();
  }
});

// ============ POLICY PAGE OVERRIDES ============
(function () {
  if (!window.location.pathname.startsWith("/policies/")) return;

  function applyPolicyOverrides() {
    // Widen container — overrides theme's 65ch/560px default
    var container = document.querySelector(".shopify-policy__container");
    if (container) container.style.maxWidth = "760px";

    // Rename refund-policy page title
    if (window.location.pathname === "/policies/refund-policy") {
      var isRtl = document.body.classList.contains("rtl");
      var h1 = document.querySelector(".shopify-policy__title h1");
      if (h1)
        h1.textContent = isRtl
          ? "سياسة الإرجاع والاستبدال"
          : "Return and Refund Policy";
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", applyPolicyOverrides);
  } else {
    applyPolicyOverrides();
  }
})();
